// extracted by mini-css-extract-plugin
export default {"tabs":"app-adminSettings-AdminSettings-module__wSpHu3zn6UdAiTnlen6b"};